export default "__VITE_ASSET__cf2fad8a__"